import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { ErrorHandlingService } from 'src/app/pages/core/services/utils/error-handling.service';

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss'],
})
export class StepTwoComponent implements OnInit {
  @Output() backStep: EventEmitter<number> = new EventEmitter();
  @Input() data;
  creationDate: Date;
  firstDateAutomaticInvestment: Date;
  isSendRule: boolean;
  constructor(
    private authService: AuthService,
    public matDialog: MatDialog,
    private router: Router,
    private errorHandlingService: ErrorHandlingService,
  ) {}

  ngOnInit(): void {
    this.firstDateAutomaticInvestment = this.setDate();
  }

  back() {
    this.backStep.emit(1);
  }

  sendRule() {
    this.isSendRule = true;
    this.authService.addRule(this.data).subscribe(
      () => {
        this.matDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: '¡Regla creada con éxito!',
              content: 'Podrás visualizar tus reglas en mis automatizaciones.',
            },
          })
          .afterClosed()
          .subscribe({
            next: () => {
              this.router.navigateByUrl('/dca');
            },
          });
      },
      (error) => {
        console.log('Error ', error);
        this.matDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: this.errorHandlingService.handleDcaRulesError(error),
          })
          .afterClosed()
          .subscribe({
            next: () => {
              this.backStep.emit(1);
            },
          });
      },
    );
  }

  setDate(): Date {
    this.creationDate = new Date();
    const currentDate = new Date();
    let hours = currentDate.getHours();
    if (this.data.runHour <= hours) {
      let day = currentDate.getDate();
      currentDate.setDate(day + 1);
      currentDate.setHours(this.data.runHour, 0);
      return currentDate;
    }
    currentDate.setHours(this.data.runHour, 0);
    return currentDate;
  }
}
